import { useEffect } from 'react'
import { useCompany } from '../../hooks/useCompany'

export const CompanyThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const { settings } = useCompany()

  useEffect(() => {
    if (!settings?.theme_config) return

    const root = document.documentElement
    const theme = settings.theme_config

    // Apply CSS variables for theme
    if (theme.primaryColor) {
      root.style.setProperty('--color-primary', theme.primaryColor)
    }
    if (theme.secondaryColor) {
      root.style.setProperty('--color-secondary', theme.secondaryColor)
    }
    if (theme.fontFamily) {
      root.style.setProperty('--font-family', theme.fontFamily)
    }

    // Apply logo preference so useLogo (app_logo) and navbar/footer show company logo
    if (theme.logo) {
      const currentLogo = localStorage.getItem('app_logo')
      if (currentLogo !== theme.logo) {
        localStorage.setItem('app_logo', theme.logo)
        window.dispatchEvent(new CustomEvent('logoChanged', { detail: { logo: theme.logo } }))
      }
    }

    return () => {
      // Cleanup: reset to defaults if needed
      root.style.removeProperty('--color-primary')
      root.style.removeProperty('--color-secondary')
      root.style.removeProperty('--font-family')
    }
  }, [settings])

  return <>{children}</>
}
